import { render, staticRenderFns } from "./AddUnitButton.vue?vue&type=template&id=4a31b384&"
import script from "./AddUnitButton.vue?vue&type=script&lang=js&"
export * from "./AddUnitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports